module.exports = __webpack_public_path__ + "assets/img/d76ca624c68b2c157f80dd7ac1969147.png";